import { Link } from "react-router-dom";

const EMAIL = "quotes@gmprint.com.au";

const CMYKBar = ({ thickness = "cmyk-bar-thick", className = "" }) => (
  <div className={`cmyk-bar ${thickness} ${className}`}>
    <div className="c" /><div className="m" /><div className="y" /><div className="k" />
  </div>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer" data-testid="footer">
      <CMYKBar className="mb-20" />
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6">
            <Link to="/" className="flex items-center gap-4 mb-6">
              <img src="/logos/gm-logo-dark.png" alt="GM Print" width={56} height={56} />
              <div>
                <div className="font-display text-2xl leading-none">GM PRINT</div>
                <div className="font-mono text-[10px] tracking-widest mt-1 text-white/60">GAIN MOMENTUM</div>
              </div>
            </Link>
            <p className="font-display text-3xl md:text-4xl leading-tight mb-4">
              Gain Momentum With Every Print.
            </p>
            <p className="font-body text-sm text-white/60 max-w-sm leading-relaxed">
              Brisbane's one-stop print, design &amp; marketing service. 100% Australian owned and operated. Servicing Queensland since 2015 — printing, signage, design and marketing under one roof.
            </p>
          </div>
          <div className="md:col-span-3">
            <h4 className="label-caps mb-5 text-white">Sitemap</h4>
            <div className="space-y-3">
              <a href="/#manifesto" className="footer-link block">Process</a>
              <a href="/#services" className="footer-link block">Services</a>
              <a href="/#industries" className="footer-link block">Industries</a>
              <a href="/#founders" className="footer-link block">Team</a>
              <Link to="/blog" className="footer-link block">Blog</Link>
              <a href="/#contact" className="footer-link block">Contact</a>
            </div>
          </div>
          <div className="md:col-span-3">
            <h4 className="label-caps mb-5 text-white">Services in Brisbane</h4>
            <div className="space-y-3">
              <Link to="/business-cards-brisbane" className="footer-link block text-sm">Business Cards</Link>
              <Link to="/signage-brisbane" className="footer-link block text-sm">Signage</Link>
              <Link to="/banners-brisbane" className="footer-link block text-sm">Banners</Link>
              <Link to="/publications-brisbane" className="footer-link block text-sm">Publications</Link>
              <Link to="/promotional-items-brisbane" className="footer-link block text-sm">Promotional Items</Link>
              <Link to="/marketing-campaigns-brisbane" className="footer-link block text-sm">Marketing Campaigns</Link>
            </div>
            <h4 className="label-caps mt-8 mb-5 text-white">Contact</h4>
            <div className="space-y-3">
              <a href={`mailto:${EMAIL}`} className="footer-link block font-mono text-sm">{EMAIL}</a>
              <a href="tel:+61467695424" className="footer-link block font-mono text-sm">Call us</a>
              <p className="text-white/60 text-sm">Brisbane, Queensland</p>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-mono text-xs text-white/50">© {currentYear} GM Print. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="/privacy-policy" className="font-mono text-xs text-white/50 hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</a>
            <a href="/terms" className="font-mono text-xs text-white/50 hover:text-white transition-colors" data-testid="footer-terms-link">Terms of Service</a>
            <p className="font-mono text-xs text-white/50">Print &amp; media specialists · Brisbane · Servicing QLD since 2015</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
